import React from 'react';
import {config} from '../../constants/Constants'
///---tabletop lib use to get spreadsheet data--///
import Tabletop from "tabletop";
  ///---Services--///
import {request} from "../../services/RequestParams";
import CalculateHash from "../../services/CalculateHash";
import loginServices from '../../services/login-service';
  ///---Shared component--///
import Spinner from "../../shared/Spinner"
  ///---View--///
import View from "../../views/Login/Login"


export default class Login extends React.Component{
    constructor(){
        super();
        this.state = { 
            formData : {},
            sheetData: {},            
            userLanguage : '',
            langCode : 2,
            msg : '',
            displayLang : sessionStorage.getItem('selectedLang'),
            forgetPass : false,
            success : false,
            spinner: false,
            error : false
        };
    }      

    componentDidMount(){
        if(sessionStorage.getItem("selectedLang") !== null){
            this.setState({userLanguage : sessionStorage.getItem("language")}) 
        }else{
            var userLang = navigator.language || navigator.userLanguage; 
            this.setState({userLanguage : userLang})
        }
        this.getGoogleSheetData(); 
        this.getLocalData();
    }

    getGoogleSheetData(){
        if(JSON.parse(sessionStorage.getItem("literals") !== null)){
            this.setState({sheetData : JSON.parse(sessionStorage.getItem("literals"))}, ()=>{console.log(this.state.sheetData)})
        }
            Tabletop.init({
            key: config.url.googleSheet,
            callback: googleData => {  
                let result = this.mapLanguages(this.state.userLanguage, googleData.Sheet1.elements);
                this.setState({sheetData : result}, ()=>{console.log(this.state.sheetData)})
                sessionStorage.setItem("literals", JSON.stringify(result));
                sessionStorage.setItem("language", (this.state.userLanguage));
                sessionStorage.setItem("menu", JSON.stringify(googleData['Dynamic Menu'].elements));
            },
            simpleSheet: false
            })
      }

  ///---Change rows into columns--///

    mapLanguages(language, languageData){
        let languageArray = {};
        if(language.split('-')[0] === 'ca'){
            this.setState({displayLang : 'Català'})
            sessionStorage.setItem("selectedLang", 'Català')
        }else if(language.split('-')[0] === 'fr'){
            this.setState({displayLang : 'Français'})
            sessionStorage.setItem("selectedLang", 'Français')
        }else if(language.split('-')[0] === 'es'){
            this.setState({displayLang : 'Español'})
            sessionStorage.setItem("selectedLang", 'Español')
        }else{
            this.setState({displayLang : 'English'})
            sessionStorage.setItem("selectedLang", 'English')
        } 
        languageData.forEach((item)=>{        
            if(item[language] !== undefined || item[language.split('-')[0]] !== undefined){
                languageArray[item.parameter] = item[language] || item[language.split('-')[0]];
            }else{
                languageArray[item.parameter] = item['en'];
            }
        })
        return languageArray;
    }


    getLocalData(){
        if(localStorage.getItem("username") !== ""){
            let obj ={
                username : localStorage.getItem("username"),
                password : localStorage.getItem("password"),
                rememberMe : localStorage.getItem("rememberMe")
            }
            this.setState({formData : obj})
        }
    }

  ///---Change language--///

    selectedLanguage(e){
        let language = e.target.ariaValueNow;
        if(language === '4'){
            this.setState({displayLang : 'Català', userLanguage : 'ca', langCode : 4})
            sessionStorage.setItem("selectedLang", 'Català')
        }else if(language === '3'){
            this.setState({displayLang : 'Français', userLanguage : 'fr', langCode : 3})
            sessionStorage.setItem("selectedLang", 'Français')
        }else if(language === '5'){
            this.setState({displayLang : 'Español', userLanguage : 'es', langCode : 5})
            sessionStorage.setItem("selectedLang", 'Español')
        }else{
            this.setState({displayLang : 'English', userLanguage : 'en', langCode : 2})
            sessionStorage.setItem("selectedLang", 'English')
        }

        this.getGoogleSheetData(); 
    }
    
  ///---Save input values in formData--///

    handleChange(event) {        
        let form = this.state.formData;
        form[event.target.name] = event.target.value;       
        this.setState({
            formData : form
        });       
    }


    handleCheckChange(event){        
        let form = this.state.formData;
        form[event.target.name] = event.target.checked;       
        this.setState({
            formData : form
        });       
    }

  ///---Submit Login form--///

    async handleSubmit(event) {
        event.preventDefault();
        this.setState({spinner : true})
        let ipark_in = request.ipark_in        
        ipark_in.ah = "";
        ipark_in.lang = this.state.langCode
        ipark_in.u = this.state.formData.username
        ipark_in.pasw = this.state.formData.password
        ipark_in.ah = CalculateHash.ah(ipark_in)        
        const userLoginObj = {ipark_in: ipark_in}
        const body = "jsonIn="+JSON.stringify(userLoginObj);
        try {
            const res = await loginServices.login(body)
            if(res.ipark_out.r === "1"){
                let obj = {
                    username : this.state.formData.username,
                    token    : res.ipark_out.token,
                    url      : res.ipark_out.url,
                    password : this.state.formData.password
                }
                sessionStorage.setItem("userInfo", JSON.stringify(obj))                
                localStorage.setItem("langCode", this.state.langCode)
                if(this.state.formData.rememberMe === true){
                    localStorage.username = this.state.formData.username
                    localStorage.password = this.state.formData.password
                    localStorage.rememberMe = this.state.formData.rememberMe
                }else{
                    localStorage.removeItem("username");
                    localStorage.removeItem("password");
                    localStorage.removeItem("rememberMe");
                }
                this.props.history.push('/home')
            }else{
                this.setState({
                    error : true, 
                    msg : this.state.sheetData.IncorrectUsernamePassword
                })                
            }
            this.setState({spinner : false})            
        } catch(err) {
            console.log(err)
        }             
    }    

  ///---Show forget pass form--///

    enableForgetPassword(){
        this.setState({forgetPass : true, success : false, error : false})
    }

  ///---Submit forget pass form--///

    async forgetPassSubmit(e){
        e.preventDefault(); 
        this.setState({spinner : true})
        let ipark_in = {   
                u : this.state.formData.username,
                ah : ""
            }
            ipark_in.ah = CalculateHash.ah(ipark_in)                                       
        const userLoginObj = {ipark_in: ipark_in}
        const body = "jsonIn="+JSON.stringify(userLoginObj); 
        try{
            const res = await loginServices.forgetPass(body)            
            if(res.ipark_out.r == 1){                
                this.setState({
                    success : true, 
                    error : false, 
                    msg : this.state.sheetData.password_sent,
                    spinner : false
                })
            }else(
                this.setState({
                    success : false, 
                    error : true, 
                    msg : this.state.sheetData.contact_fragment_email_validation_error,
                    spinner : false                
                })
            )
        } catch(err) {
            console.log(err)
        }         
    }    

    goBack(){
        this.setState({forgetPass : false, error : false, success : false})
    }

    render(){
        return( 
            <>
                <View 
                    formData = {this.state.formData}
                    sheetData = {this.state.sheetData}
                    error = {this.state.error}
                    success = {this.state.success}
                    msg = {this.state.msg}
                    forgetPass = {this.state.forgetPass}
                    displayLang = {this.state.displayLang}

                    selectedLanguage = {(e) => {this.selectedLanguage(e)}}
                    handleSubmit = {(e) => {this.handleSubmit(e)}}
                    handleChange = {(e) => {this.handleChange(e)}}
                    enableForgetPassword = {() => {this.enableForgetPassword()}}
                    forgetPassSubmit = {(e) => {this.forgetPassSubmit(e)}}
                    goBack = {() => {this.goBack()}}
                />
                <Spinner 
                    spinner = {this.state.spinner}
                />                
            </>
        )
    }
}